import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";
import { initBrowserMonitoring } from "./lib/sentry";
import { installHistoryEventsGuard } from "./lib/history-events-guard";

// Task #812: stand up the browser Sentry SDK before any app code mounts so
// the top-level error boundary (Task #772) can capture render-time crashes
// and surface a tracking ID. No-op when `VITE_SENTRY_DSN` isn't set.
initBrowserMonitoring();

// Keep wouter's history event patch alive: third-party widgets can restore
// the native history.pushState, after which URL changes stop re-rendering
// the router ("URL changes but the page doesn't load until refresh").
installHistoryEventsGuard();

createRoot(document.getElementById("root")!).render(<App />);
